import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IBulkAction } from '@shared/interfaces/bulk-action.interface';

@Component({
  selector: 'app-bulk-action-bar',
  templateUrl: './bulk-action-bar.component.html',
  standalone: false
})
export class BulkActionBarComponent {
  @Input() public count = 0;
  @Input() public total = 0;
  @Input() public allMatching = false;
  @Input() public canSelectAll = false;
  @Input() public actions: IBulkAction[] = [];
  @Output() public selectAll = new EventEmitter<void>();
  @Output() public clear = new EventEmitter<void>();

  public get visibleActions(): IBulkAction[] {
    return this.actions.filter((a) => a.visible !== false);
  }
}
